<section class="light-blue">
    <div class="row">
        <div class="col-lg-12">
            <img src="../../../assets/img/under-maintence.svg" class="image-logo img-fluid" alt="under maintence">
            <h4>{{labelConstant.title}}</h4>
            <p>{{labelConstant.mainParagraph}}<br />
                {{labelConstant.paragraph}}</p>
        </div>
    </div>
</section>